module.exports = __webpack_public_path__ + "static/media/photo11.9e0a3480.jpg";